module.exports = __webpack_public_path__ + "static/media/Gilroy-Light-Italic.60997757.woff2";